import React, { useEffect, useState } from 'react';
import NovaeonMark from '../logo/logo';
import { styles, INTRO_MARK_SIZE } from './styles';
import { COLORS } from '../../globalStyles';
import { prefersReducedMotion } from '../../utils';

/**
 * First-load intro:
 *  0  black screen
 *  1  fade in the logo (centered)
 *  2  fade in the wordmark beneath it
 *  3  logo docks — shrink + move the mark to the header position
 *  4  wordmark docks a beat later — slides up beside the mark
 *  5  fade the black overlay away, revealing the page
 *  6  done — unmount, restore scrolling
 * Scroll is locked for the whole sequence (~2.5s). Skipped under reduced-motion.
 */
const IntroSequence: React.FC = () => {
  const [phase, setPhase] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const prefersReduced = prefersReducedMotion();
    if (prefersReduced) {
      setDone(true);
      return;
    }

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.scrollTo(0, 0);

    const timers = [
      window.setTimeout(() => setPhase(1), 185),   // logo fades in
      window.setTimeout(() => setPhase(2), 730),   // wordmark fades in
      window.setTimeout(() => setPhase(3), 1340),  // logo docks
      window.setTimeout(() => setPhase(4), 1490),  // wordmark docks (overlaps logo travel)
      window.setTimeout(() => setPhase(5), 2195),  // overlay fades away
      window.setTimeout(() => setDone(true), 2500),
    ];

    return () => {
      timers.forEach(clearTimeout);
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  useEffect(() => {
    if (done) document.body.style.overflow = '';
  }, [done]);

  if (done) return null;

  const markDocked = phase >= 3;
  const wordDocked = phase >= 4;
  const revealing = phase >= 5;

  return (
    <div
      style={{
        ...styles.overlay,
        opacity: revealing ? 0 : 1,
        pointerEvents: revealing ? 'none' : 'auto',
      }}
      aria-hidden={true}
    >
      <div style={{ ...styles.markBox, ...(markDocked ? styles.markBoxDocked : styles.markBoxIntro) }}>
        <div style={{ ...styles.mark, opacity: phase >= 1 ? 1 : 0 }}>
          <NovaeonMark size={INTRO_MARK_SIZE} bg={COLORS.bg} />
        </div>
      </div>
      <span
        style={{
          ...styles.wordmark,
          ...(wordDocked ? styles.wordmarkDocked : styles.wordmarkIntro),
          opacity: phase >= 2 ? 1 : 0,
        }}
      >
        Novaeon
      </span>
    </div>
  );
};

export default IntroSequence;
